Page.Reception = Class.create(Page.Base, {
  name: 'reception',
  css: `
        .page.reception { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: #fff; color: #000; }

        .page.reception > .panels {
            display: flex;
            flex-direction: row;
            width: 100%;
            min-height: 100%;
        }

        .page.reception > .panels > .panelNavigation {
            width: 82px;
            min-width: 82px;
            padding: 20px 0 0 0px;
            transition: width 0.2s ease, min-width 0.2s ease;
        }

        .page.reception > .panels > .panelContent {
            flex: 1;
            padding: 30px 30px 30px 31px;
            position: relative;
            /* border-left: 1px solid #ddd;
            background: linear-gradient(to right, #f6f6f6 0px, #fff 5px), linear-gradient(to bottom, #fff 0px, rgba(255,255,255,0) 30px);
            */

            background: 
                linear-gradient(to bottom, #fff 0px, rgba(255,255,255,0) 30px), 
                linear-gradient(to right, #fff 0px, #ddd 1px, #f6f6f6 1px, #fff 6px);  

        }


        /* Expanded state - wider sidebar with labels */

        .page.reception[data-state=expanded] > .panels > .panelNavigation { width: 180px; min-width: 180px; }


        /* Navigation items */

        .page.reception .receptionNav { list-style: none; margin: 0; padding: 0 0 0 23px; }

        .page.reception .receptionNav li {
            display: flex;
            align-items: center;
            height: 40px;
            margin-bottom: 8px;
            cursor: pointer;
            color: #666;
        }

        .page.reception .receptionNav li.selected { color: var(--colors-blue); }

        .page.reception .receptionNav li .icon {
            width: 36px;
            min-width: 36px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            font-family: SalonIcon;
            font-size: 26px;
            border-radius: 6px;
        }

        .page.reception .receptionNav li:hover .icon { background: var(--button-hover-background); }
        .page.reception .receptionNav li:active .icon { background: var(--button-active-background); }

        .page.reception .receptionNav li .label {
            white-space: nowrap;
            font-size: 0.75em;
            font-weight: var(--font-weight-bold);
            opacity: 0;
            transform: translateX(-8px);
            transition: opacity 0.15s ease, transform 0.15s ease;
            pointer-events: none;
        }

        .page.reception[data-state=expanded] .receptionNav li .label {
            opacity: 1;
            transform: translateX(4px);
            pointer-events: auto;
        }


        /* Expanded viewport */

        body[data-viewport=expand] .page.reception {
            position: static;
            width: 1000px;
            min-height: 100vh;
        }

        body[data-viewport=expand] .page.reception > .panels { min-height: 100vh; }

        body[data-viewport=expand] .page.reception > .panels > .panelContent {
            width: 918px;
            overflow-x: hidden;
        }
    `,
  initPage: function () {
    this.classList.add('scrollWrapper');
    this.internal.container.tabIndex = -1;

    /* Default to expanded state */
    this.internal.sidebarState = 'expanded';
    this.dataset.state = 'expanded';

    /* Define sidebarState property with getter/setter */
    this.defineProperty('sidebarState', {
      get: function () {
        return this.internal.sidebarState;
      }.bind(this),
      set: function (value) {
        if (value === 'expanded' || value === 'collapsed') {
          this.internal.sidebarState = value;
          this.dataset.state = value;
        }
      }.bind(this)
    });
    var panels = new Element('div', {
      'class': 'panels scrollContainer'
    });
    this.appendChild(panels);
    this.navigation = new Element('div', {
      'class': 'panelNavigation'
    });
    panels.appendChild(this.navigation);
    this.content = new Element('div', {
      'class': 'panelContent'
    });
    panels.appendChild(this.content);
  },
  expandSidebar: function () {
    this.sidebarState = 'expanded';
  },
  collapseSidebar: function () {
    this.sidebarState = 'collapsed';
  }
});

/**
 * Page.Reception.Navigation
 *
 * Custom navigation component for the reception page with icon buttons and animated labels.
 */
Page.Reception.Navigation = Class.create();
Page.Reception.Navigation.prototype = {
  initialize: function (parent, options) {
    this.options = Object.assign({
      items: [],
      onChange: null
    }, options);
    this.parent = parent;
    this.items = [];
    this.selected = null;

    /* Find the page element to check sidebar state */
    this.page = parent.closest('.page.reception');
    this.container = new Element('ul', {
      'class': 'receptionNav'
    });
    parent.appendChild(this.container);
    for (var i = 0; i < this.options.items.length; i++) {
      this.addItem(this.options.items[i], i === 0);
    }
  },
  addItem: function (config, selected) {
    var item = {
      id: config.id || null,
      title: config.title,
      icon: config.icon,
      tooltip: config.tooltip,
      element: null
    };
    var li = new Element('li');
    item.element = li;

    /* Icon */
    var icon = new Element('span', {
      'class': 'icon'
    });
    if (config.icon && config.icon.character) {
      icon.update(config.icon.character);
    }
    li.appendChild(icon);

    /* Label */
    var label = new Element('span', {
      'class': 'label'
    });
    label.update(config.title.escapeHTML());
    li.appendChild(label);

    /* Tooltip for collapsed state only */
    if (config.tooltip) {
      var page = this.page;
      tippy(li, {
        content: config.tooltip,
        placement: 'right',
        delay: 500,
        theme: 'salonhub',
        onShow: function () {
          /* Only show tooltip when sidebar is collapsed */
          if (page && page.dataset.state === 'expanded') {
            return false;
          }
        }
      });
    }

    /* Click handler */
    li.observe('click', function () {
      this.select(item);
    }.bind(this));
    this.container.appendChild(li);
    this.items.push(item);
    if (selected) {
      this.select(item, true);
    }
  },
  select: function (item, silent) {
    /* Deselect previous */
    if (this.selected && this.selected.element) {
      this.selected.element.classList.remove('selected');
    }

    /* Select new */
    this.selected = item;
    item.element.classList.add('selected');

    /* Notify */
    if (!silent && this.options.onChange) {
      this.options.onChange(item.id);
    }
  },
  get value() {
    return this.selected ? this.selected.id : null;
  },
  set value(id) {
    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].id === id) {
        this.select(this.items[i], true);
        break;
      }
    }
  }
};
//# sourceMappingURL=reception.js.map
